(function() {
  'use strict';

  // Parse link rules from JSON
  function getLinkRules() {
    const script = document.querySelector('script[data-link-rules]');
    if (!script) return [];
    
    try {
      const data = JSON.parse(script.textContent);
      return data.rules || [];
    } catch (e) {
      console.warn('Link Rules: Failed to parse JSON', e);
      return [];
    }
  }

  // Get link rule code from data attribute
  function getLinkRuleCode(link) {
    return link.dataset.linkRule ? link.dataset.linkRule.trim() : null;
  }

  // Check if this is the first occurrence of a code in a list
  function isFirstOccurrence(element, code) {
    const container = element.closest('.main-list, .secondary-list, .submenu-inner, .links, .links.module, .menu-links');
    if (!container) return true;
    
    const links = Array.from(container.querySelectorAll('a, button[type="button"]'));
    const currentLink = element.closest('a, button[type="button"]');
    if (!currentLink) return true;
    
    // Find index of current link
    const currentIndex = links.indexOf(currentLink);
    if (currentIndex === -1) return true;
    
    // Check if any link before this one has the same code
    for (let i = 0; i < currentIndex; i++) {
      const linkCode = getLinkRuleCode(links[i]);
      if (linkCode === code) {
        return false;
      }
    }
    
    return true;
  }

  // Apply button styling
  function applyButtonStyle(link, rule) {
    const linkElement = link.closest('a, button');
    if (!linkElement) return;
    
    // Add button classes
    linkElement.classList.add('btn', 'v1');
    
    // Add has-button class to parent
    const parent = linkElement.closest('.item');
    if (parent) {
      parent.classList.add('has-button');
    }
  }

  // Apply custom color
  function applyCustomColor(link, rule) {
    const linkElement = link.closest('a, button');
    if (!linkElement || !rule.custom_font_color) return;
    
    linkElement.style.color = rule.custom_font_color;
    linkElement.classList.add('color-custom');
    
    // Also apply to badge if exists
    const badge = linkElement.querySelector('.badge');
    if (badge) {
      badge.style.color = rule.custom_font_color;
    }
  }

  // Insert label before link
  function insertLabel(link, rule) {
    if (!rule.label_text) return;
    
    const linkElement = link.closest('a, button');
    if (!linkElement) return;
    
    const parent = linkElement.closest('.item');
    if (!parent) return;
    
    // Check if this is first occurrence
    if (!isFirstOccurrence(linkElement, rule.code)) {
      return;
    }
    
    // Check if label already exists for this code
    const existingLabel = parent.previousElementSibling;
    if (existingLabel && 
        existingLabel.classList.contains('label-item') &&
        existingLabel.dataset.labelCode === rule.code) {
      return;
    }
    
    // Create label element
    const labelItem = document.createElement('div');
    labelItem.className = 'item label-item';
    labelItem.dataset.labelCode = rule.code;
    labelItem.innerHTML = `<div class="label small-label">${rule.label_text}</div>`;
    
    // Insert before parent item
    parent.parentNode.insertBefore(labelItem, parent);
  }

  // Process a single link
  function processLink(link) {
    // Skip if already processed
    if (link.dataset.linkRulesProcessed === 'true') return;
    
    // Get code from data attribute
    const code = getLinkRuleCode(link);
    
    if (!code) return;
    
    const rules = getLinkRules();
    const rule = rules.find(r => r.code && r.code.trim() === code);
    
    if (!rule) return;
    
    // Mark as processed
    link.dataset.linkRulesProcessed = 'true';
    
    // No need to remove bracket code from text - it's already removed in Liquid
    // The title is already clean when rendered
    
    // Apply rule based on action
    switch (rule.action) {
      case 'button':
        applyButtonStyle(link, rule);
        break;
      case 'color':
        applyCustomColor(link, rule);
        break;
      case 'label':
        insertLabel(link, rule);
        break;
    }
  }

  // Process all links in a container
  function processLinks(container) {
    if (!container) return;
    
    // Find all links that have data-link-rule attribute
    const links = container.querySelectorAll('a[data-link-rule], button[type="button"][data-link-rule]');
    
    links.forEach(link => {
      // Skip if already processed
      if (link.dataset.linkRulesProcessed === 'true') return;
      
      processLink(link);
    });
  }

  // Initialize link rules processor
  function initLinkRules() {
    const selectors = [
      '#mobile-menu',
      '.header-main-menu',
      '.mega-menu-content',
      '.mega-menu',
      '.submenu-inner',
      '.links.module',
      '.menu-links',
      'nav.header-main-menu'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => processLinks(el));
    });
    
    // Watch for dynamically added content in mobile menu
    const mobileMenu = document.querySelector('#mobile-menu');
    if (mobileMenu && !mobileMenu.dataset.linkRulesObserved) {
      mobileMenu.dataset.linkRulesObserved = 'true';
      
      const observer = new MutationObserver(mutations => {
        let shouldProcess = false;
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              shouldProcess = true;
            }
          });
        });
        
        if (shouldProcess) {
          // Debounce processing
          clearTimeout(mobileMenu._linkRulesTimeout);
          mobileMenu._linkRulesTimeout = setTimeout(() => {
            processLinks(mobileMenu);
          }, 50);
        }
      });
      
      observer.observe(mobileMenu, {
        childList: true,
        subtree: true
      });
    }
  }

  // Run on DOM ready
  function runInit() {
    initLinkRules();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
  
  // Also run after delays to catch dynamically loaded content
  setTimeout(runInit, 100);
  setTimeout(runInit, 500);
  setTimeout(runInit, 1000);
  
  // Listen for custom events that might indicate menu updates
  document.addEventListener('mobileMenuLoaded', runInit);
  document.addEventListener('megaMenuLoaded', runInit);
  
  // Expose for manual triggering if needed
  window.LinkRules = {
    init: initLinkRules,
    processLinks: processLinks,
    processLink: processLink
  };
})();

